import Article from './article';

const articleConfig = {
  name: 'article',
  class: Article,
  querySelector: {
    content: '.article-content',
    inlineRelatedStories: '.inline-related-stories',
  },
  querySelectorAll: {
    slideshowBlock: '.wp-block-jetpack-slideshow',
    galleryBlock: '.wp-block-gallery',
  },
  options: {
    readMoreButtonClass: 'article-read-more-button',
    articleCondensedClass: 'article--is-condensed',
    slideshowCaptionClass: '.wp-block-jetpack-slideshow_caption',
    galleryCaptionClass: '.blocks-gallery-item__caption',
  },
};

export default articleConfig;

